import angular from 'angular';
import {
  loaderService,
  reportsDataService
} from 'app/services';
import { alerts } from 'app/components/global';

import directive from './report-type.directive';
import controller from './report-type.controller';

import reportInstances from './reportInstances';
import bulkArchiveReportInstancesDialog from './dialog.bulkArchiveReportInstancesDialog';
import bulkDeleteReportInstancesDialog from './dialog.bulkDeleteReportInstancesDialog';

export default angular.module('app.components.reports.myReports.reportType', [
  loaderService,
  reportsDataService,
  alerts,
  reportInstances,
  bulkArchiveReportInstancesDialog,
  bulkDeleteReportInstancesDialog
])
  .directive('mrReportType', directive)
  .controller('MRReportTypeController', controller)
  .name;

console.log('app.components.reports.myReports.reportType created');
